import type { IconData } from '@stacksjs/iconify-core'

export const ne4x3: IconData = {
  "body": "<path fill=\"#0db02b\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M0 0h640v320H0z\"/><path fill=\"#e05206\" d=\"M0 0h640v160H0z\"/><circle cx=\"320\" cy=\"240\" r=\"68\" fill=\"#e05206\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ne4x3
